
import React from 'react';
import { Language } from '../../types';

interface RobotEmptyStateProps {
  language: Language;
  onBack: () => void;
  onAddAgent: () => void;
  isRtl: boolean;
}

const RobotEmptyState: React.FC<RobotEmptyStateProps> = ({ language, onBack, onAddAgent, isRtl }) => {
  return (
    <div className="flex h-full w-full bg-slate-50 dark:bg-[#050507] flex-col relative overflow-hidden font-sans transition-colors duration-500">
       <div className="absolute top-0 left-0 right-0 h-20 flex items-center justify-between px-6 lg:px-8 z-50 pointer-events-none">
          <button onClick={onBack} className="pointer-events-auto w-10 h-10 rounded-xl bg-white/80 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 flex items-center justify-center text-slate-500 transition-colors backdrop-blur-sm shadow-sm">
             <i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i>
          </button>
       </div>
       <div className="flex-1 flex flex-col items-center justify-center p-6 text-center animate-in fade-in zoom-in-95 duration-500">
          <div className="relative w-40 h-40 mb-8">
             <div className="absolute inset-0 bg-emerald-500/20 blur-[50px] rounded-full animate-pulse"></div>
             <div className="relative w-full h-full bg-white dark:bg-[#1a1a20] rounded-[2.5rem] flex items-center justify-center text-7xl text-slate-300 dark:text-slate-600 shadow-2xl border border-slate-100 dark:border-white/5">
                <i className="fas fa-robot"></i>
             </div>
             <div className="absolute -bottom-3 -right-3 w-12 h-12 bg-emerald-500 rounded-2xl flex items-center justify-center text-white shadow-lg animate-[bounce_2s_infinite]">
                <i className="fas fa-plus"></i>
             </div>
          </div>
          <h2 className="text-3xl font-black text-slate-800 dark:text-white mb-4">{isRtl ? 'لا يوجد وكلاء نشطين' : 'No Active Agents'}</h2>
          <button onClick={onAddAgent} className="px-10 py-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl font-black text-sm shadow-2xl shadow-emerald-500/30 transition-all hover:scale-105 active:scale-95 flex items-center gap-3">
             <i className="fas fa-plus-circle"></i>{isRtl ? 'إنشاء وكيل جديد' : 'Create New Agent'}
          </button>
       </div>
    </div>
  );
};
export default RobotEmptyState;
